import { FrontWebSongModel} from "../../../generated";
import { SongBox } from "../../Item/Song/SongBox";
import SongSliderCss from "./SongSlider.module.css";
import {ReactNode, useEffect, useRef, useState} from "react";
import { SongRowList} from "./SongRowList";


export const SongSlider = (props: {
    title: ReactNode,
    items: FrontWebSongModel[],

}) => {

    const maxItems =  6;
    const h2ref = useRef<HTMLHeadingElement|null>(null)
    const [row, setRow] = useState(false);

    useEffect(()=>{
        if ((props.items?.length ?? 0) === 0 )
            return;

        const f = () => {
            if (h2ref.current) {
                const width = h2ref.current?.getBoundingClientRect().width;
                if (width >= 1032) {
                    setRow(false);
                } else {
                    setRow(true);
                }
            }
        };
        f();
        window.addEventListener("resize", f);
        return () => window.removeEventListener("resize", f);

    }, [props.items]);

    if ((props.items?.length ?? 0) === 0)
        return null;

    const songs = props.items.filter((_, key) => key < maxItems);
    return <>
        <h2 ref={h2ref} className={'h2 mb-24px text-center'}>{props.title}</h2>
        { row ? <SongRowList items={songs} twoItemsPerRowMain={true} /> : <>
            <ul className={`d-flex flex-wrap justify-content-between ${SongSliderCss.songList}`}>
                {songs.map(x => <li  key={x.id}><SongBox className={`p-1 ${SongSliderCss.songSliderItem}`} song={x}/></li>)}
            </ul>
        </>}
   </>
}